// extracted by mini-css-extract-plugin
export var btnOpener = "light-box-image-module--btn-opener--dec45";
export var captionContainer = "light-box-image-module--caption-container--47548";
export var imagesContainer = "light-box-image-module--images-container--47fea";